var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/fragments/cart.ts
var cartFields = (
  /* GraphQL */
  `
  fragment cartFields on CartPayload {
    id
    items {
      id
      price {
        currency
        units
      }
      product {
        id
        mpn
        title
        thumbnail {
          src
        }
      }
      quantity
      attributes {
        name
        value
      }
    }
    totals {
      subTotal {
        currency
        units
      }
    }
  }
`
);
var cart_default = cartFields;

// src/mutations/activate-license.ts
var activateLicense = (
  /* GraphQL */
  `
  mutation activateLicense($id: String!) {
    activateLicense(id: $id) {
      id
    }
  }
`
);
var activate_license_default = activateLicense;

// src/mutations/add-product-to-cart.ts
var addProductToCart = (
  /* GraphQL */
  `
  mutation addProductToCart($input: CartAddInput) {
    cart(input: { add: $input }) {
      add {
        cart {
          ...cartFields
        }
      }
    }
  }
  ${cart_default}
`
);
var add_product_to_cart_default = addProductToCart;

// src/mutations/change-product-in-cart.ts
var changeProductInCart = (
  /* GraphQL */
  `
  mutation changeProductInCart($input: CartChangeInput) {
    cart(input: { change: $input }) {
      change {
        cart {
          ...cartFields
        }
      }
    }
  }
  ${cart_default}
`
);
var change_product_in_cart_default = changeProductInCart;

// src/mutations/create-user.ts
var createUser = (
  /* GraphQL */
  `
  mutation createUser2($user: CreateUserInput!) {
    createUser2(user: $user)
  }
`
);
var create_user_default = createUser;

// src/mutations/remove-discount.ts
var removeDiscount = (
  /* GraphQL */
  `
  mutation removeDiscount($input: String!) {
    checkout(input: { removeDiscount: { code: $input } }) {
      totals {
        subTotal {
          currency
          units
        }
        shippingTotal {
          currency
          units
        }
        taxTotal {
          currency
          units
        }
        discountTotal {
          currency
          units
        }
        total {
          currency
          units
        }
      }
      steps {
        ... on PayflowCheckoutStepPayload {
          id
          token {
            id
            value
          }
        }
        ... on ShippingAddressCheckoutStepPayload {
          id
          requiredFields
          invalidFields {
            name
            message
          }
        }
        ... on ShippingOptionsCheckoutStepPayload {
          id
          shippingOptions {
            id
            carrier
            cost
            name
          }
        }
        ... on BillingAddressCheckoutStepPayload {
          id
          requiredFields
          invalidFields {
            name
            message
          }
        }
        ... on DiscountCheckoutStepPayload {
          id
          code
          invalidFields {
            name
            message
          }
        }
        ... on FOCCheckoutStepPayload {
          id
        }
        ... on InvoiceCheckoutStepPayload {
          id
        }
      }
      discount {
        discounts {
          code
        }
        errorMessage
      }
    }
  }
`
);
var remove_discount_default = removeDiscount;

// src/mutations/remove-product-from-cart.ts
var removeProductFromCart = (
  /* GraphQL */
  `
  mutation removeProductFromCart($input: CartRemoveInput) {
    cart(input: { remove: $input }) {
      remove {
        cart {
          ...cartFields
        }
      }
    }
  }
  ${cart_default}
`
);
var remove_product_from_cart_default = removeProductFromCart;

// src/mutations/set-billing-address.ts
var setBillingAddress = (
  /* GraphQL */
  `
  mutation setBillingAddress($input: AddressInput!) {
    checkout(input: { setBillingAddress: { address: $input } }) {
      totals {
        subTotal {
          currency
          units
        }
        shippingTotal {
          currency
          units
        }
        taxTotal {
          currency
          units
        }
        discountTotal {
          currency
          units
        }
        total {
          currency
          units
        }
      }
      steps {
        ... on PayflowCheckoutStepPayload {
          id
          token {
            id
            value
          }
        }
        ... on ShippingAddressCheckoutStepPayload {
          id
          requiredFields
          invalidFields {
            name
            message
          }
        }
        ... on ShippingOptionsCheckoutStepPayload {
          id
          shippingOptions {
            id
            carrier
            cost
            name
          }
        }
        ... on BillingAddressCheckoutStepPayload {
          id
          requiredFields
          invalidFields {
            name
            message
          }
        }
        ... on DiscountCheckoutStepPayload {
          id
          code
          invalidFields {
            name
            message
          }
        }
        ... on FOCCheckoutStepPayload {
          id
        }
        ... on InvoiceCheckoutStepPayload {
          id
        }
      }
    }
  }
`
);
var set_billing_address_default = setBillingAddress;

// src/mutations/set-discount.ts
var setDiscount = (
  /* GraphQL */
  `
  mutation setDiscount($input: String!) {
    checkout(input: { setDiscount: { code: $input } }) {
      totals {
        subTotal {
          currency
          units
        }
        shippingTotal {
          currency
          units
        }
        taxTotal {
          currency
          units
        }
        discountTotal {
          currency
          units
        }
        total {
          currency
          units
        }
      }
      steps {
        ... on PayflowCheckoutStepPayload {
          id
          token {
            id
            value
          }
        }
        ... on ShippingAddressCheckoutStepPayload {
          id
          requiredFields
          invalidFields {
            name
            message
          }
        }
        ... on ShippingOptionsCheckoutStepPayload {
          id
          shippingOptions {
            id
            carrier
            cost
            name
          }
        }
        ... on BillingAddressCheckoutStepPayload {
          id
          requiredFields
          invalidFields {
            name
            message
          }
        }
        ... on DiscountCheckoutStepPayload {
          id
          code
          invalidFields {
            name
            message
          }
        }
        ... on FOCCheckoutStepPayload {
          id
        }
        ... on InvoiceCheckoutStepPayload {
          id
        }
      }
      discount {
        discounts {
          code
        }
        errorMessage
      }
    }
  }
`
);
var set_discount_default = setDiscount;

// src/mutations/set-shipping-address.ts
var setShippingAddress = (
  /* GraphQL */
  `
  mutation setShippingAddress($input: AddressInput!) {
    checkout(input: { setShippingAddress: { address: $input } }) {
      totals {
        subTotal {
          currency
          units
        }
        shippingTotal {
          currency
          units
        }
        taxTotal {
          currency
          units
        }
        discountTotal {
          currency
          units
        }
        total {
          currency
          units
        }
      }
      steps {
        ... on PayflowCheckoutStepPayload {
          id
          token {
            id
            value
          }
        }
        ... on ShippingAddressCheckoutStepPayload {
          id
          requiredFields
          invalidFields {
            name
            message
          }
        }
        ... on ShippingOptionsCheckoutStepPayload {
          id
          shippingOptions {
            id
            carrier
            cost
            name
          }
        }
        ... on BillingAddressCheckoutStepPayload {
          id
          requiredFields
          invalidFields {
            name
            message
          }
        }
        ... on DiscountCheckoutStepPayload {
          id
          code
          invalidFields {
            name
            message
          }
        }
        ... on FOCCheckoutStepPayload {
          id
        }
        ... on InvoiceCheckoutStepPayload {
          id
        }
      }
    }
  }
`
);
var set_shipping_address_default = setShippingAddress;

// src/mutations/submit-foc.ts
var submitFOC = (
  /* GraphQL */
  `
  mutation submitFOCOrder {
    submitFOCOrder {
      orderNumber
    }
  }
`
);
var submit_foc_default = submitFOC;

// src/mutations/submit-invoice.ts
var mutation = (
  /* GraphQL */
  `
  mutation submitInvoice {
    order: submitInvoiceOrder {
      orderNumber
    }
  }
`
);
var submit_invoice_default = mutation;

// src/constants.ts
var GET_TOKEN_ENDPOINT = process.env.NEXT_PUBLIC_TOKEN_URL;
var SITE = process.env.NEXT_PUBLIC_SITE;
var GRAPHQL_ENDPOINT = process.env.NEXT_PUBLIC_BACKEND_URL;
var LOGIN_URL = process.env.NEXT_PUBLIC_LOGIN_URL;
var PAYFLOW_URL = process.env.NEXT_PUBLIC_PAYFLOW_URL;
var AWS_URL = process.env.NEXT_PUBLIC_AWS_URL;
var API_URL = process.env.NEXT_PUBLIC_API_URL;

// src/graphql.ts
var request = ({ query, token, variables = {} }) => {
  const operationName = /(query|mutation) ([a-zA-Z0-9]+)/.exec(query)[2];
  const body = {
    operationName,
    query,
    variables
  };
  const headers = {
    "Content-Type": "application/json",
    "X-CORE-SITE": SITE
  };
  if (token) {
    headers["Authorization"] = "Bearer " + token;
  }
  return fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers,
    body: JSON.stringify(body)
  });
};

// src/operations/activate-license.ts
var activateLicense2 = (token, id) => __async(void 0, null, function* () {
  const response = yield request({
    query: activate_license_default,
    variables: {
      id
    },
    token
  });
  const responseBody = yield response.json();
  return responseBody == null ? void 0 : responseBody.data.activateLicense;
});
var activate_license_default2 = activateLicense2;

// src/operations/add-product-to-cart.ts
var addProductToCart2 = (token, input) => __async(void 0, null, function* () {
  const body = {
    query: add_product_to_cart_default,
    variables: {
      input
    }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return responseBody == null ? void 0 : responseBody.data.cart.add.cart;
});
var add_product_to_cart_default2 = addProductToCart2;

// src/operations/change-product-in-cart.ts
var changeProductInCart2 = (token, input) => __async(void 0, null, function* () {
  const body = {
    query: change_product_in_cart_default,
    variables: {
      input
    }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return responseBody == null ? void 0 : responseBody.data.cart.change.cart;
});
var change_product_in_cart_default2 = changeProductInCart2;

// src/operations/create-user.ts
var createUser2 = (token, user) => __async(void 0, null, function* () {
  const response = yield request({
    query: create_user_default,
    variables: {
      user
    },
    token
  });
  const responseBody = yield response.json();
  return responseBody == null ? void 0 : responseBody.data.createUser2;
});
var create_user_default2 = createUser2;

// src/queries/get-all-products.ts
var getAllProductsQuery = (
  /* GraphQL */
  `
  query getAllProducts {
    products2 {
      all {
        products {
          id
          mpn
          title
          thumbnail {
            src
          }
          category: attribute(type: "description")
          description: attribute(type: "longdescription")
          defaultVariant {
            id
            title
            description
            price {
              currency
              units
            }
          }
        }
      }
    }
  }
`
);
var get_all_products_default = getAllProductsQuery;

// src/operations/fetch-all-products.ts
var fetchAllProducts = () => __async(void 0, null, function* () {
  var _a, _b, _c;
  const body = {
    query: get_all_products_default,
    variables: {}
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return (_c = (_b = (_a = responseBody == null ? void 0 : responseBody.data) == null ? void 0 : _a.products2) == null ? void 0 : _b.all) == null ? void 0 : _c.products;
});
var fetch_all_products_default = fetchAllProducts;

// src/queries/get-checkout.ts
var getCheckout = (
  /* GraphQL */
  `
  query getCheckout {
    checkout {
      totals {
        subTotal {
          currency
          units
        }
        shippingTotal {
          currency
          units
        }
        taxTotal {
          currency
          units
        }
        discountTotal {
          currency
          units
        }
        total {
          currency
          units
        }
      }
      shippingAddress {
        attention
        company
        address1
        address2
        city
        country
        stateProvince: state
        postalCode
        email
        phone
      }
      billingAddress {
        attention
        company
        address1
        address2
        city
        country
        stateProvince: state
        postalCode
        email
        phone
      }
      discount {
        discounts {
          code
        }
        errorMessage
      }
      steps {
        ... on PayflowCheckoutStepPayload {
          id
          token {
            id
            value
          }
        }
        ... on ShippingAddressCheckoutStepPayload {
          id
          requiredFields
          invalidFields {
            name
            message
          }
        }
        ... on ShippingOptionsCheckoutStepPayload {
          id
          shippingOptions {
            id
            carrier
            cost
            name
          }
        }
        ... on BillingAddressCheckoutStepPayload {
          id
          requiredFields
          invalidFields {
            name
            message
          }
        }
        ... on DiscountCheckoutStepPayload {
          id
          code
          invalidFields {
            name
            message
          }
        }
        ... on FOCCheckoutStepPayload {
          id
        }
        ... on InvoiceCheckoutStepPayload {
          id
        }
      }
    }
  }
`
);
var get_checkout_default = getCheckout;

// src/operations/fetch-checkout.ts
var fetchCheckout = (token) => __async(void 0, null, function* () {
  var _a;
  const body = {
    query: get_checkout_default,
    variables: {}
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return (_a = responseBody == null ? void 0 : responseBody.data) == null ? void 0 : _a.checkout;
});
var fetch_checkout_default = fetchCheckout;

// src/queries/get-completions.ts
var getCompletions = (
  /* GraphQL */
  `
  query getCompletions($request: CriteriaRequest!) {
    completions(request: $request) {
      content {
        id
        name
        email
        company
        course
        complete
        enabled
        completionDate(format: "ISO8601Date")
        accountId
        customerId
        certificatePurchased
        courseObject {
          id
          courseName
        }
        registrationInfo {
          data {
            code
            value
          }
          orderInfo {
            code
            value
          }
        }
        product {
          id
          name
          sku
          set
        }
      }
      totalPages
      totalElements
      page
      size
    }
  }
`
);
var get_completions_default = getCompletions;

// src/operations/fetch-completions.ts
var fetchCompletions = (token, request2) => __async(void 0, null, function* () {
  const body = {
    query: get_completions_default,
    variables: { request: request2 }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return responseBody == null ? void 0 : responseBody.data;
});
var fetch_completions_default = fetchCompletions;

// src/queries/get-countries.ts
var getCountries = (
  /* GraphQL */
  `
  query getCountries {
    countries {
      code
      name
    }
  }
`
);
var get_countries_default = getCountries;

// src/operations/fetch-countries.ts
var fetchCountries = () => __async(void 0, null, function* () {
  var _a;
  const body = {
    query: get_countries_default,
    variables: {}
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return (_a = responseBody == null ? void 0 : responseBody.data) == null ? void 0 : _a.countries;
});
var fetch_countries_default = fetchCountries;

// src/queries/get-user-completions.ts
var getUserCompletions = (
  /* GraphQL */
  `
  query userCompletionList($request: CriteriaRequest!) {
    completions: userCompletionList(request: $request) {
      id
      name
      email
      company
      course
      coursePackageId
      coursePackageName
      coursePackageDescription
      coursePackagePrerequisitesMet
      isLegacyCourse
      groupId
      complete
      createdDate
      lastActivity
      completionDate
      accountId
      customerId
      registrationInfo {
        data {
          code
          value
        }
        orderInfo {
          code
          value
        }
      }
      certificatePurchased
      courseObject {
        id
        variantPackages {
          variant
          packages {
            id
            name
            description
            launch
            prerequisites {
              packageId
              packageName
            }
          }
        }
        allowDigitalWallet
      }
      product {
        id
        name
        sku
        set
        products {
          id
          name
          sku
          attributes {
            code
            value
          }
          variants {
            price
            name
            type
          }
        }
        attributes {
          code
          value
        }
        variants {
          price
          name
          type
        }
        media {
          type
          url
        }
      }
      thumbnail {
        id
        images {
          contentType
          filename
          src
          type
        }
      }
    }
  }
`
);
var get_user_completions_default = getUserCompletions;

// src/operations/fetch-course-completions.ts
var fetchCourseCompletions = (token) => __async(void 0, null, function* () {
  const body = {
    query: get_user_completions_default,
    variables: {
      request: {
        page: 0,
        size: 1e3,
        criteria: []
      }
    }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return responseBody == null ? void 0 : responseBody.data;
});
var fetch_course_completions_default = fetchCourseCompletions;

// src/queries/get-customer.ts
var getCustomer = (
  /* GraphQL */
  `
  query getCustomer($id: String!) {
    customer(id: $id) {
      id
      firstName
      lastName
      email
    }
  }
`
);
var get_customer_default = getCustomer;

// src/operations/fetch-customer.ts
var fetchCustomer = (token, id) => __async(void 0, null, function* () {
  console.log(id);
  const body = {
    query: get_customer_default,
    variables: { id }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  console.log(responseBody);
  return responseBody == null ? void 0 : responseBody.data;
});
var fetch_customer_default = fetchCustomer;

// src/queries/get-customer-and-cart.ts
var getCustomerAndCart = (
  /* GraphQL */
  `
  query getCustomerAndCart {
    customer {
      id
      email
      firstName
      lastName
      guest
    }
    cart: cart2 {
      ...cartFields
    }
  }
  ${cart_default}
`
);
var get_customer_and_cart_default = getCustomerAndCart;

// src/operations/fetch-customer-state.ts
var fetchUserState = (token) => __async(void 0, null, function* () {
  const operationName = /query ([a-zA-z0-9]*) /.exec(get_customer_and_cart_default)[1];
  const body = {
    operationName,
    query: get_customer_and_cart_default,
    variables: {}
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return responseBody == null ? void 0 : responseBody.data;
});
var fetch_customer_state_default = fetchUserState;

// src/queries/get-license-by-email.ts
var getLicenseByEmail = (
  /*GraphQL*/
  `
  query licenseByEmail($page: Int!, $size: Int!) {
    page:licenseByEmail(page: $page, size: $size) {
      content {
        id
        accountId
        type
        ownerId
        ownerEmail
        customerId
        customerEmail
        orderId
        expiration
        attributes {
            code
            value
        }
        completionStatus
      }
      totalPages
      totalElements
      page
      size
    }
  }
`
);
var get_license_by_email_default = getLicenseByEmail;

// src/operations/fetch-licenses.ts
var fetchLicenses = (token, page, size) => __async(void 0, null, function* () {
  const response = yield request({
    query: get_license_by_email_default,
    variables: { page, size },
    token
  });
  const responseBody = yield response.json();
  return responseBody == null ? void 0 : responseBody.data;
});
var fetch_licenses_default = fetchLicenses;

// src/queries/get-order.ts
var getOrder = (
  /* GraphQL */
  `
  query getOrder($orderId: String!) {
    order(orderId: $orderId) {
      id
      orderNumber
      customer
      subtotal
      discountTotal
      total
      shippingTotal
      handlingTotal
      taxTotal
      shippingMethod
      date
      poNumber
      shippingFirstName
      shippingLastName
      shippingCompany
      shippingAddress1
      shippingAddress2
      shippingCity
      shippingCounty
      shippingState
      shippingCountry
      shippingPostalCode
      shippingPhone
      shippingEmail
      billingFirstName
      billingLastName
      billingCompany
      billingAddress1
      billingAddress2
      billingCity
      billingCounty
      billingState
      billingCountry
      billingPostalCode
      billingPhone
      billingEmail
      ccTransNumber
      status {
        statusCode
        title
        description
      }
      cart {
        title
        soldPrice
        listPrice
        productCost
        deliveryFormat
        mediaFormat
        qtySold
        qtyShipped
        product {
          name
          attributes {
            code
            value
          }
        }
        attributes {
          code
          value
        }
      }
      attributes {
        code
        value
      }
    }
  }
`
);
var get_order_default = getOrder;

// src/operations/fetch-order.ts
var fetchOrder = (token, orderNumber) => __async(void 0, null, function* () {
  const body = {
    query: get_order_default,
    variables: { orderId: orderNumber }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return responseBody == null ? void 0 : responseBody.data;
});
var fetch_order_default = fetchOrder;

// src/queries/get-product-by-handle.ts
var getProductByHandle = (
  /* GraphQL */
  `
  query getProductByHandle($handle: String) {
    products2 {
      product(input: { handle: $handle }) {
        id
        mpn
        title
        thumbnail {
          src
        }
        category: attribute(type: "description")
        description: attribute(type: "longdescription")
        longDescription: attribute(type: "coursedescription")
        defaultVariant {
          id
          title
          description
          price {
            currency
            units
          }
        }
      }
    }
  }
`
);
var get_product_by_handle_default = getProductByHandle;

// src/operations/fetch-product.ts
var fetchProduct = (_0) => __async(void 0, [_0], function* ({ handle }) {
  var _a, _b;
  const body = {
    query: get_product_by_handle_default,
    variables: {
      handle
    }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return (_b = (_a = responseBody == null ? void 0 : responseBody.data) == null ? void 0 : _a.products2) == null ? void 0 : _b.product;
});
var fetch_product_default = fetchProduct;

// src/queries/get-states.ts
var getStates = (
  /* GraphQL */
  `
  query getStates($countryCode: String) {
    states(countryCode: $countryCode) {
      code: stateCode
      name
    }
  }
`
);
var get_states_default = getStates;

// src/operations/fetch-states.ts
var fetchStates = (countryCode) => __async(void 0, null, function* () {
  var _a;
  const body = {
    query: get_states_default,
    variables: { countryCode }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return (_a = responseBody == null ? void 0 : responseBody.data) == null ? void 0 : _a.states;
});
var fetch_states_default = fetchStates;

// src/operations/get-token.ts
import cookie from "js-cookie";
var getToken = () => __async(void 0, null, function* () {
  const cookieToken = cookie.get("token");
  const response = yield fetch(GET_TOKEN_ENDPOINT, {
    method: "POST",
    headers: {
      Authorization: cookieToken ? `Bearer ${cookieToken}` : "",
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE
    }
  });
  const responseBody = yield response.json();
  return responseBody == null ? void 0 : responseBody.token;
});
var get_token_default = getToken;

// src/operations/invite-by-license.ts
var inviteByLicense = (_0) => __async(void 0, [_0], function* ({ code, email }) {
  const response = yield fetch(`${API_URL}/license/invite/${code}/${email}`, {
    method: "GET",
    // mode: 'no-cors',
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: `Bearer ${yield get_token_default()}`
    }
  });
  const message = yield response.text();
  return {
    message
  };
});
var invite_by_license_default = inviteByLicense;

// src/queries/query-orders.ts
var queryOrdersQuery = (
  /* GraphQL */
  `
  query getUserOrders($request: CriteriaRequest!) {
    page: userOrders(request: $request) {
      content {
        id
        orderNumber
        customer
        subtotal
        discountTotal
        total
        shippingTotal
        handlingTotal
        taxTotal
        date
        shippingMethod
        poNumber
        shippingFirstName
        shippingLastName
        shippingCompany
        shippingAddress1
        shippingAddress2
        shippingCity
        shippingCounty
        shippingState
        shippingCountry
        shippingPostalCode
        shippingPhone
        shippingEmail
        billingFirstName
        billingLastName
        billingCompany
        billingAddress1
        billingAddress2
        billingCity
        billingCounty
        billingState
        billingCountry
        billingPostalCode
        billingPhone
        billingEmail
        ccTransNumber
        status {
          statusCode
          title
          description
        }
        cart {
          id
          title
          soldPrice
          listPrice
          productCost
          deliveryFormat
          mediaFormat
          qtySold
          qtyShipped
          attributes {
            code
            value
          }
        }
      }
      totalPages
      totalElements
      page
      size
    }
    statuses: ordersStatuses {
      statusCode
      title
      description
    }
  }
`
);
var query_orders_default = queryOrdersQuery;

// src/operations/query-orders.ts
var queryOrders = (_0) => __async(void 0, [_0], function* ({
  token,
  request: request2
}) {
  const body = {
    query: query_orders_default,
    variables: {
      request: request2
    }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return responseBody == null ? void 0 : responseBody.data;
});
var query_orders_default2 = queryOrders;

// src/operations/remind-by-license.ts
var remindByLicense = (_0) => __async(void 0, [_0], function* ({ code }) {
  const response = yield fetch(`${API_URL}/license/remind/${code}`, {
    method: "GET",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE
    }
  });
  const message = yield response.text();
  return {
    message
  };
});
var remind_by_license_default = remindByLicense;

// src/operations/remove-discount.ts
var removeDiscount2 = (token, input) => __async(void 0, null, function* () {
  var _a;
  const body = {
    query: remove_discount_default,
    variables: {
      input
    }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return (_a = responseBody == null ? void 0 : responseBody.data) == null ? void 0 : _a.checkout;
});
var remove_discount_default2 = removeDiscount2;

// src/operations/remove-product-from-cart.ts
var removeProductFromCart2 = (token, input) => __async(void 0, null, function* () {
  const body = {
    query: remove_product_from_cart_default,
    variables: {
      input
    }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return responseBody == null ? void 0 : responseBody.data.cart.remove.cart;
});
var remove_product_from_cart_default2 = removeProductFromCart2;

// src/operations/set-billing-address.ts
var setBillingAddress2 = (token, input) => __async(void 0, null, function* () {
  var _a;
  const body = {
    query: set_billing_address_default,
    variables: {
      input
    }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return (_a = responseBody == null ? void 0 : responseBody.data) == null ? void 0 : _a.checkout;
});
var set_billing_address_default2 = setBillingAddress2;

// src/operations/set-discount.ts
var setDiscount2 = (token, input) => __async(void 0, null, function* () {
  var _a;
  const body = {
    query: set_discount_default,
    variables: {
      input
    }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return (_a = responseBody == null ? void 0 : responseBody.data) == null ? void 0 : _a.checkout;
});
var set_discount_default2 = setDiscount2;

// src/operations/set-shipping-address.ts
var setShippingAddress2 = (token, input) => __async(void 0, null, function* () {
  var _a;
  const body = {
    query: set_shipping_address_default,
    variables: {
      input
    }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return (_a = responseBody == null ? void 0 : responseBody.data) == null ? void 0 : _a.checkout;
});
var set_shipping_address_default2 = setShippingAddress2;

// src/mutations/set-shipping-option.ts
var setShippingOption = (
  /* GraphQL */
  `
  mutation setShippingOption($id: String!) {
    checkout(input: { setShippingOption: { id: $id } }) {
      totals {
        subTotal {
          currency
          units
        }
        shippingTotal {
          currency
          units
        }
        taxTotal {
          currency
          units
        }
        discountTotal {
          currency
          units
        }
        total {
          currency
          units
        }
      }
      steps {
        ... on PayflowCheckoutStepPayload {
          id
          token {
            id
            value
          }
        }
        ... on ShippingAddressCheckoutStepPayload {
          id
          requiredFields
          invalidFields {
            name
            message
          }
        }
        ... on ShippingOptionsCheckoutStepPayload {
          id
          shippingOptions {
            id
            carrier
            cost
            name
          }
        }
        ... on BillingAddressCheckoutStepPayload {
          id
          requiredFields
          invalidFields {
            name
            message
          }
        }
        ... on DiscountCheckoutStepPayload {
          id
          code
          invalidFields {
            name
            message
          }
        }
        ... on FOCCheckoutStepPayload {
          id
        }
        ... on InvoiceCheckoutStepPayload {
          id
        }
      }
    }
  }
`
);
var set_shipping_option_default = setShippingOption;

// src/operations/set-shipping-option.ts
var setShippingOption2 = (token, id) => __async(void 0, null, function* () {
  var _a;
  const body = {
    query: set_shipping_option_default,
    variables: {
      id
    }
  };
  const response = yield fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token
    },
    body: JSON.stringify(body)
  });
  const responseBody = yield response.json();
  return (_a = responseBody == null ? void 0 : responseBody.data) == null ? void 0 : _a.checkout;
});
var set_shipping_option_default2 = setShippingOption2;

// src/operations/submit-foc.ts
var submitFOC2 = (token) => __async(void 0, null, function* () {
  var _a;
  const response = yield request({
    query: submit_foc_default,
    variables: {},
    token
  });
  const responseBody = yield response.json();
  return (_a = responseBody == null ? void 0 : responseBody.data) == null ? void 0 : _a.submitFOCOrder;
});
var submit_foc_default2 = submitFOC2;

// src/operations/submit-invoice.ts
var submitInvoice = (token) => __async(void 0, null, function* () {
  var _a;
  const response = yield request({
    query: submit_invoice_default,
    variables: {},
    token
  });
  const responseBody = yield response.json();
  return (_a = responseBody == null ? void 0 : responseBody.data) == null ? void 0 : _a.order;
});
var submit_invoice_default2 = submitInvoice;

// src/types/address.ts
function newAddress() {
  return {
    attention: "",
    company: "",
    address1: "",
    address2: "",
    city: "",
    stateProvince: "",
    country: "",
    postalCode: "",
    email: "",
    phone: ""
  };
}

// src/types/checkout-discount.ts
function newDiscount() {
  return {
    discounts: [],
    errorMessage: ""
  };
}

// src/types/checkout-step.ts
function isPayflowStep(step) {
  return step.id === "payflow";
}
function isShippingStep(step) {
  return step.id === "shippingAddress";
}
function isShippingOptionsStep(step) {
  return step.id === "shippingOptions";
}
function isInvoiceStep(step) {
  return step.id === "invoice";
}
function isBillingStep(step) {
  return step.id === "billingAddress";
}
function isDiscountStep(step) {
  return step.id === "discount";
}
function isFOCStep(step) {
  return step.id === "foc";
}

// src/types/fa-icon-color.ts
var FaIconColor = {
  Primary: "rgb(45, 45, 45)",
  Secondary: "#A8B6BE"
};
var fa_icon_color_default = FaIconColor;

// src/types/fa-icon-type.ts
var FaIconType = {
  Globe: "\\f0ac",
  Email: "\\f0e0",
  Cart: "\\f07a",
  AngleDown: "\\f107",
  AngleUp: "\\f106",
  AngleLeft: "\\f104",
  CheckCircle: "\\f058",
  Circle: "\\f111",
  Search: "\\f002",
  Hamburger: "\\f0c9",
  Copy: "\\f0c5"
};
var fa_icon_type_default = FaIconType;

// src/attributes.ts
function getAttribute(attributes, attribute) {
  let returnAttribute = attributes.find((a) => a.code === attribute);
  if ((returnAttribute == null ? void 0 : returnAttribute.value) === void 0) {
    return "";
  }
  return returnAttribute.value ? returnAttribute.value : "";
}

// src/money.ts
function formatMoney(price) {
  if (isPrice(price)) {
    return Intl.NumberFormat("en-US", {
      style: "currency",
      currency: price.currency
    }).format(price.units / 100);
  } else {
    return Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(price);
  }
}
function isPrice(price) {
  return price.currency !== void 0;
}
export {
  API_URL,
  AWS_URL,
  fa_icon_color_default as FaIconColor,
  fa_icon_type_default as FaIconType,
  GET_TOKEN_ENDPOINT,
  GRAPHQL_ENDPOINT,
  LOGIN_URL,
  PAYFLOW_URL,
  SITE,
  activate_license_default as activateLicenseMutation,
  activate_license_default2 as activateLicenseOperation,
  add_product_to_cart_default as addProductToCartMutation,
  add_product_to_cart_default2 as addProductToCartOperation,
  cart_default as cartFields,
  change_product_in_cart_default as changeProductInCartMutation,
  change_product_in_cart_default2 as changeProductInCartOperation,
  create_user_default as createUserMutation,
  create_user_default2 as createUserOperation,
  fetch_all_products_default as fetchAllProductsOperation,
  fetch_checkout_default as fetchCheckoutOperation,
  fetch_completions_default as fetchCompletionsOperation,
  fetch_countries_default as fetchCountriesOperation,
  fetch_course_completions_default as fetchCourseCompletionsOperation,
  fetch_customer_default as fetchCustomerOperation,
  fetch_licenses_default as fetchLicensesOperation,
  fetch_order_default as fetchOrderOperation,
  fetch_product_default as fetchProductOperation,
  fetch_states_default as fetchStatesOperation,
  fetch_customer_state_default as fetchUserStateOperation,
  formatMoney,
  get_all_products_default as getAllProductsQuery,
  getAttribute,
  get_checkout_default as getCheckoutQuery,
  get_completions_default as getCompletionsQuery,
  get_countries_default as getCountriesQuery,
  get_customer_and_cart_default as getCustomerAndCartQuery,
  get_customer_default as getCustomerQuery,
  get_license_by_email_default as getLicenseByEmailQuery,
  get_order_default as getOrderQuery,
  get_product_by_handle_default as getProductByHandleQuery,
  get_states_default as getStatesQuery,
  get_token_default as getTokenOperation,
  get_user_completions_default as getUserCompletionsQuery,
  invite_by_license_default as inviteByLicenseOperation,
  isBillingStep,
  isDiscountStep,
  isFOCStep,
  isInvoiceStep,
  isPayflowStep,
  isShippingOptionsStep,
  isShippingStep,
  newAddress,
  newDiscount,
  query_orders_default2 as queryOrdersOperation,
  query_orders_default as queryOrdersQuery,
  remind_by_license_default as remindByLicenseOperation,
  remove_discount_default as removeDiscountMutation,
  remove_discount_default2 as removeDiscountOperation,
  remove_product_from_cart_default as removeProductFromCartMutation,
  remove_product_from_cart_default2 as removeProductFromCartOperation,
  request,
  set_billing_address_default as setBillingAddressMutation,
  set_billing_address_default2 as setBillingAddressOperation,
  set_discount_default as setDiscountMutation,
  set_discount_default2 as setDiscountOperation,
  set_shipping_address_default as setShippingAddressMutation,
  set_shipping_address_default2 as setShippingAddressOperation,
  set_shipping_option_default2 as setShippingOptionOperation,
  submit_foc_default as submitFOCMutation,
  submit_foc_default2 as submitFOCOperation,
  submit_invoice_default as submitInvoiceMutation,
  submit_invoice_default2 as submitInvoiceOperation
};
